const FaceRecognition = () => import('@/views/FaceRecognition')

export default [
  {
    path: '/faceRecognition',
    component: FaceRecognition,
    meta: { requireAuth: true }
  }
]
